window.onload = function() {
  const updateYotpoWidget = (yotpoWidget, updatedSelectors) => {
    const targetSelectors = [
      '.yotpo-reward-steps-item.yotpo-reward-steps-item-1',
      '.yotpo-container-headline',
      '.yotpo-vip-tiers-headline'
    ];

    targetSelectors.forEach(selector => {
      const div = yotpoWidget.querySelector(selector);
      if (div && !div.querySelector('.online-only-msg')) {
        let onlineOnlyMsg = document.createElement('p');
        onlineOnlyMsg.classList.add('online-only-msg');
        onlineOnlyMsg.textContent = 'APPLICABLE ONLINE ONLY';
        div.appendChild(onlineOnlyMsg);
        updatedSelectors.add(selector);
      }
    });
  };

  const updateWithLink = (updatedLinks) => {
    const updateWithLinkDivs = document.querySelectorAll('.yotpo-description');
    const targetText = 'LINK for your FREE Teeny Tiny Band During Stack Week';
    const linkHref = 'https://www.helloadorn.com/collections/stack-week?utm_id=stackweek24gwp_teenytinyband';
  
    updateWithLinkDivs.forEach(div => {
      if (div && div.textContent.includes(targetText)) {
        // Create a new link element
        let stackWeekLink = document.createElement('a');
        stackWeekLink.classList.add('stack-week-link');
        stackWeekLink.href = linkHref;
        stackWeekLink.textContent = targetText;
  
        // Find the text node containing the target text
        let textNode = Array.from(div.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.textContent.includes(targetText));
        if (textNode) {
          // Split the text node at the target text
          let parts = textNode.textContent.split(targetText);
          let beforeText = document.createTextNode(parts[0]);
          let afterText = document.createTextNode(parts[1]);
  
          // Clear the div and append the new nodes
          div.textContent = '';
          div.appendChild(beforeText);
          div.appendChild(stackWeekLink);
          div.appendChild(afterText);
  
          updatedLinks.add(div);
        }
      }
    });
  };

  const addOrderHistoryButton = () => {
    const buttonContainers = document.querySelectorAll('.yotpo-action-buttons-tile');
    buttonContainers.forEach(container => {
      // Avoid adding multiple times
      if (container.querySelector('.custom-yotpo-button')) return;
      
      // Create the button wrapper div
      const buttonDiv = document.createElement('div');
      buttonDiv.className = 'yotpo-action-button-widget yotpo-action-button custom-yotpo-button';
      
      // Create the button element
      const button = document.createElement('button');
      button.setAttribute('tabindex', '0');
      button.setAttribute('aria-label', 'ORDER HISTORY');
      button.className = 'yotpo-button-style yotpo-button-standard-size yotpo-filled-button yotpo-rectangular-btn-type';
      button.setAttribute('style', 'color: rgb(255, 255, 255); background: rgb(170, 121, 87); border: 1px solid rgb(170, 121, 87);');
      
      // Create the span for button text
      const span = document.createElement('span');
      span.className = 'yopto-widget-button-text';
      span.setAttribute('style', 'font-size: 18px; font-family: Brother1816; font-weight: 400; font-style: normal;');
      span.textContent = 'ORDER HISTORY';
      
      button.appendChild(span);
      buttonDiv.appendChild(button);
      
      // Add click handler
      button.addEventListener('click', function() {
        window.location.href = '/account#order-history';
      });
      
      // Insert as the third child (after first two buttons/links)
      const children = Array.from(container.children);
      if (children.length >= 2) {
        container.insertBefore(buttonDiv, children[2]);
      } else {
        container.appendChild(buttonDiv);
      }
    });
  };

  const updateYotpo = function(mutationsList, observer) {
    let yotpoWidget = document.querySelector('.yotpo-widget-loyalty-page');
    if (!yotpoWidget) return;

    let updatedSelectors = new Set();
    let updatedLinks = new Set();

    // Temporarily disconnect the observer to prevent infinite loop
    observer.disconnect();

    updateYotpoWidget(yotpoWidget, updatedSelectors);
    updateWithLink(updatedLinks);
    addOrderHistoryButton();

    // Reconnect the observer after making changes
    if (updatedSelectors.size === 3 && updatedLinks.size === document.querySelectorAll('.yotpo-description').length) {
      observer.disconnect();
    } else {
      observer.observe(document.body, config);
    }
  };

  const observer = new MutationObserver(updateYotpo);
  const config = { childList: true, subtree: true };
  observer.observe(document.body, config);
};